export default __webpack_public_path__ + "static/media/resource-room-featured-image-placeholder.8bc3f168.svg";